

/**
 * NotFound component displays a user not found or error message with refresh instructions.
 */
const NotFound = () => {

    return (
        <>
            <div className='container vh-100'>
                <div className="d-flex flex-column align-items-center  p-2 mt-6" style={{ backgroundColor: "#fff" }}>
                    <div className='d-flex justify-content-center'>
                        <img
                            src={`/media/auth/error.png`}
                            className=""
                            alt=""
                            style={{ width: '300px', height: '300px' }}
                        />
                    </div>

                    <div
                        style={{ border: '1px solid #dadada' }}
                        className="card card-flush w-lg-650px "
                    >
                        <div
                            style={{ background: '#FBF6F7', minHeight: '39px' }}
                            className="card-header p-3"
                        >
                            <div style={{ color: '#FF4141' }} className="card-title">
                                Refresh
                            </div>
                        </div>
                        <div className="card-body p-3">
                            <div style={{ color: '#000' }} className="fs-6">
                                If you're having trouble with your authentication credentials, please click on refresh
                                <></>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default NotFound